import { Injectable } from '@angular/core';
import { RoleGuard } from './role.abstract.guard';

@Injectable({ providedIn: 'root' })
export class MarketingGuard extends RoleGuard {
  role: string[] = ['marketing'];
}
